import { render, staticRenderFns } from "./JtProfilePermission.vue?vue&type=template&id=d7cd9556&scoped=true"
import script from "./JtProfilePermission.vue?vue&type=script&lang=js"
export * from "./JtProfilePermission.vue?vue&type=script&lang=js"
import style0 from "./JtProfilePermission.vue?vue&type=style&index=0&id=d7cd9556&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7cd9556",
  null
  
)

export default component.exports